var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:flex md:items-center"},[_c('div',{staticClass:"flex-grow hidden md:block mr-8"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"md:w-[400px]"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }